export const API_BASE =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_API
        : "http://localhost:4002";

export const DASSIST_TICKET_FILES_BASE =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_DASSIST_TICKET_FILES
        : "http://localhost:4001";

export const DTIME_LEAVE_FILES_BASE =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_DTIME_LEAVE_FILES
        : "http://localhost:4003";

export const DBUG_TICKET_FILES_BASE =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_DBUG_TICKET_FILES
        : "http://localhost:4004";

// dSlip hosts the reimbursement receipt files; dAdmin only links to them.
// Falls back to the dSlip domain so it works even without REACT_APP_DSLIP_FILE set.
export const DSLIP_FILE_BASE =
    process.env.NODE_ENV === "production"
        ? (process.env.REACT_APP_DSLIP_FILE || "https://dslip.dolluzcorp.com")
        : "http://localhost:4007";

// An admin revoking someone in Inside D -> Login Page Config now ends their
// session as well as their "remember me". The server answers 401 SESSION_REVOKED
// on the next request; without this the page would just render broken data and
// leave the person apparently signed in.
//
// Handled here rather than per page so it cannot be forgotten by one caller.
// Guarded so a burst of parallel requests cannot trigger a redirect loop, and
// skipped on the sign-in routes themselves, where a 401 is an ordinary answer.
let sessionEnded = false;

export async function apiFetch(endpoint, options = {}) {
    const res = await fetch(`${API_BASE}${endpoint}`, {
        credentials: "include",
        ...options,
    });

    if (res.status === 401 && !sessionEnded && !endpoint.startsWith("/api/login/")) {
        // Read from a clone so the caller still gets an unconsumed body.
        let message = "";
        try { message = (await res.clone().json())?.message || ""; } catch { /* not JSON */ }
        if (message === "SESSION_REVOKED") {
            sessionEnded = true;
            window.location.replace("/Login?revoked=1");
        }
    }

    return res;
}
